import type {RootState} from '@/state/store';

export const selectInitialData = (state: RootState) => state.uwm.initialData;
export const selectModuleDetails = (state: RootState) => state.uwm.moduleDetails;
export const selectIsDarkMode = (state: RootState) => state.uwm.initialData?.isDarkMode ?? false;
export const selectIsInitialized = (state: RootState) => state.uwm.moduleDetails?.isInitialized ?? false;
export const selectInitializationError = (state: RootState) => state.uwm.initializationError;

export const selectIsContentLoaded = (state: RootState) => state.uwm.isContentLoaded;

export const selectIsModuleReady = (state: RootState) =>
    Boolean(state.uwm.moduleDetails?.isInitialized) &&
    state.uwm.isContentLoaded &&
    state.inference.inferenceData != null &&
    state.uwm.initializationError == null;
